import React, { Fragment, useState } from 'react'
import { getSidebarLinks } from './sidebarConfig';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Avatar from '../images/avatar.png';

const SideBarLinks = ({ isExpanded, hoverExpand, handleClick, logoutUser, role, setShowSupport }) => {
  const hoverColors = [
    { bg: "sweep-blue", text: "group-hover:text-blue-600" },
    { bg: "sweep-purple", text: "group-hover:text-purple-600" },
    { bg: "sweep-orange", text: "group-hover:text-orange-600" },
    { bg: "sweep-pink", text: "group-hover:text-pink-600" },
    { bg: "sweep-indigo", text: "group-hover:text-indigo-600" },
  ];


  const { user } = useSelector((state) => state.verifyEmailStore);

  const SIDEBAR_LINKS = getSidebarLinks(user);


  const [openGroups, setOpenGroups] = useState({});


  const toggleGroup = (id) => {
    setOpenGroups(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };



  const filteredSidebarLinks = SIDEBAR_LINKS.map(section => {
    const filteredItems = section.items
      .filter(item => !item.roles || item.roles.includes(role))
      .map(item => {
        if (item.type === "group") {
          // Filter children
          const filteredChildren = item.children?.filter(child => !child.roles || child.roles.includes(role));
          return { ...item, children: filteredChildren };
        }
        return item;
      });
    return { ...section, items: filteredItems };
  });





  return (
    <Fragment>
      <div className="flex flex-col flex-1 w-full text-slate-800 dark:text-slate-200 font-medium pb-8 font-jakarta">
        {filteredSidebarLinks.map((section) => (
          <div key={section.heading}>

            {/* HEADING */}
            {(isExpanded || hoverExpand) && (
              <div className="text-[12px] pl-6 pt-6 pb-2 uppercase text-[#2a3547] dark:text-slate-400 font-bold tracking-wider">
                {section.heading}
              </div>
            )}

            {/* ITEMS */}
            {section.items.map((item, index) => {
              const colorTheme = hoverColors[index % hoverColors.length];
              // ------------------------
              // NORMAL LINK
              // ------------------------
              if (item.type === "link") {
                return (
                  <Link
                    key={item.id}
                    to={item.to}
                    id={item.id}
                    onClick={handleClick}
                    className={`flex items-center gap-4 ${isExpanded || hoverExpand ? "pl-6 pr-4 w-[90%] rounded-r-full py-2.5" : "justify-center w-12 h-12 rounded-xl mx-auto"} mt-[2px] ${colorTheme.bg} transition-all duration-300 headerLinks group`}
                  >
                    <i
                      className={`${item.icon} text-[#5a6a85] dark:text-slate-400 ${colorTheme.text} ${isExpanded || hoverExpand ? "text-[20px] w-6" : "text-xl"} text-center transition-all duration-300`}
                    ></i>
                    {(isExpanded || hoverExpand) && (
                      <span className={`font-normal text-[15px] text-[#2a3547] dark:text-slate-200 tracking-wide ${colorTheme.text} transition-colors duration-300`}>
                        {item.label}
                      </span>
                    )}
                  </Link>
                );
              }

              // ------------------------
              // GROUP (WITH SUB LINKS)
              // ------------------------

              if (item.type === "group") {
                return (
                  <div key={item.id}>

                    {/* GROUP BUTTON */}
                    <button
                      onClick={() => {
                        if (item?.id === "Support") {
                          setShowSupport(true)
                          handleClick()
                        } else {
                          toggleGroup(item.id)

                        }
                      }}
                      className={`flex items-center gap-4 ${isExpanded || hoverExpand ? "pl-6 pr-4 w-[90%] rounded-r-full py-2.5" : "justify-center w-12 h-12 rounded-xl mx-auto"} mt-[2px] ${colorTheme.bg} transition-all duration-300 headerLinks group`}
                      id={item.id}

                    >
                      <i
                        className={`${item.icon} text-[#5a6a85] dark:text-slate-400 ${colorTheme.text} ${isExpanded || hoverExpand ? "text-[20px] w-6" : "text-xl"} text-center transition-all duration-300`}
                      ></i>
                      {(isExpanded || hoverExpand) && (
                        <div className="flex justify-between w-full items-center pr-2 group">
                          <span className={`font-normal text-[15px] text-[#2a3547] dark:text-slate-200 tracking-wide ${colorTheme.text} transition-colors duration-300`}>
                            {item.label}
                          </span>
                          {item?.id !== "Support" &&
                          <i className={`fa-solid fa-chevron-${openGroups[item.id] ? "up" : "down"} text-[11px] text-[#5a6a85] dark:text-slate-400 transition-transform duration-300`}></i>

                          }
                        </div>
                      )}
                    </button>

                    {/* SUB LINKS */}
                    {

                      <div
                        className={`overflow-hidden transition-all duration-300 ${(isExpanded || hoverExpand) && openGroups[item.id]
                          ? "block lg:max-h-[30rem] opacity-100 py-1"
                          : "hidden max-h-0 opacity-0"
                          }`}
                      >

                        {item.children?.map((sub) => (
                          <Link
                            key={sub.id}
                            to={sub.to}
                            id={sub.id}

                            onClick={handleClick}
                            className={`ml-8 py-2 px-4 mt-1 rounded-full text-[14px] font-normal tracking-wide text-[#5a6a85] dark:text-slate-400 ${colorTheme.text} ${colorTheme.bg} w-[85%] group subLinks flex items-center transition-all duration-300`}
                          >
                            <span className="inline-block w-[5px] h-[5px] border-[1px] border-[#5a6a85] dark:border-slate-500 rounded-full mr-3 group-hover:bg-current group-hover:border-current transition-colors duration-300"></span>
                            <div>

                              {sub.label}
                            </div>
                          </Link>
                        ))}
                      </div>

                    }
                  </div>
                );
              }

              // ------------------------
              // LOGOUT BUTTON / PROFILE CARD
              // ------------------------
              if (item.type === "logout") {
                return (
                  <div key={item.id} className="mt-auto pt-6 w-full mb-4">
                    <div 
                      className={`${isExpanded || hoverExpand ? "bg-[#E8F7FF] dark:bg-sky-500/10 rounded-xl p-3 flex items-center justify-between mx-4" : "bg-[#E8F7FF] dark:bg-sky-500/10 rounded-xl w-12 h-12 flex items-center justify-center mx-auto cursor-pointer hover:scale-105"} shadow-sm transition-all duration-300 border border-transparent dark:border-slate-800`} 
                      onClick={(!isExpanded && !hoverExpand) ? logoutUser : undefined}
                    >
                      <div className="flex items-center gap-3 overflow-hidden">
                        <img src={Avatar} alt="user" className={`rounded-full object-cover shrink-0 ${isExpanded || hoverExpand ? "w-10 h-10" : "w-8 h-8"}`} />
                        {(isExpanded || hoverExpand) && (
                          <div className="flex flex-col whitespace-nowrap overflow-hidden">
                            <span className="text-sm font-bold text-slate-800 dark:text-slate-100 truncate max-w-[120px]">{user?.name || "User"}</span>
                            <span className="text-xs text-slate-500 dark:text-slate-400">{user?.role || "Role"}</span>
                          </div>
                        )}
                      </div>
                      {(isExpanded || hoverExpand) && (
                        <button onClick={logoutUser} className="text-blue-600 dark:text-sky-400 hover:scale-110 transition-transform">
                          <i className="fa-solid fa-arrow-right-from-bracket text-lg"></i>
                        </button>
                      )}
                    </div>
                  </div>
                );
              }

              return null;

            })}
          </div>
        ))}
      </div>

    </Fragment>
  )
}

export default SideBarLinks
